import React, { useCallback, useEffect, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import moment from 'moment';

import t, { partial } from '../../../util/translation/translation';

import DisplayCounter from '../../_uiComponents/DisplayCounter';
import config from '../../../config';
import EmailIcon from 'mdi-react/EmailIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import CellphoneMessageIcon from 'mdi-react/CellphoneMessageIcon';
import Api from '../../../util/api';
import Loading from '../../../shared/components/custom/Loading';

const CommunicationTransactionsList = () => {
  const s = partial('shared');
  const p = partial('transactions');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const smsCommission = config?.commission?.sms;
  const emailCommission = config?.commission?.email;
  const [startEndObject, setStartEndObject] = useState({
    start: null,
    end: null,
    type: 'allTime',
  });
  const handleStartEnd = (filter) => {
    let internal = {
      start: null,
      end: null,
      type: filter,
    };
    switch (filter) {
      case 'allTime':
        internal.start = null;
        internal.end = null;
        break;
      case 'thisYear':
        internal.start = moment().startOf('year').toISOString();
        internal.end = moment().endOf('year').toISOString();
        break;
      case 'lastYear':
        internal.start = moment()
          .subtract(1, 'year')
          .startOf('year')
          .toISOString();
        internal.end = moment().subtract(1, 'year').endOf('year').toISOString();
        break;
      default:
        internal.start = null;
        internal.end = null;
        break;
    }
    setStartEndObject(internal);
  };

  const fetchCommunicationsDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Api.transactions.getMessagesStatistics({
        startDate: startEndObject.start,
        endDate: startEndObject.end,
      });
      setData(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [startEndObject.end, startEndObject.start]);
  useEffect(() => {
    fetchCommunicationsDetails();
  }, [fetchCommunicationsDetails]);

  return (
    <>
      <Loading loading={loading} />
      <Nav pills>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('allTime')}
            active={startEndObject.type === 'allTime'}
          >
            {s('allTime')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('thisYear')}
            active={startEndObject.type === 'thisYear'}
          >
            {s('thisYear')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            role="button"
            onClick={() => handleStartEnd('lastYear')}
            active={startEndObject.type === 'lastYear'}
          >
            {s('lastYear')}
          </NavLink>
        </NavItem>
      </Nav>
      <div className="my-2">
        <DisplayCounter
          id="sms"
          color="premium"
          title={`Sms ${s('sent')}`}
          value={`${data?.sms || 0}`}
          icon={<CellphoneMessageIcon style={{ width: 18 }} />}
        />

        {smsCommission && (
          <DisplayCounter
            id="sms2"
            title={`Sms ${s('sent')}`}
            value={`${data?.sms || 0 * (smsCommission || 0)} ${config.currencyShortSmall}`}
            text={
              smsCommission &&
              p('costPerSms', {
                commission: smsCommission,
                currency: config.currencyShortSmall,
              })
            }
            icon={<CellphoneIcon style={{ width: 18 }} />}
          />
        )}
      </div>
      <div className="my-2">
        <DisplayCounter
          id="email"
          color="secondary"
          title={`Email ${s('sent')}`}
          value={`${data?.emails || 0}`}
          icon={<EmailIcon style={{ width: 18 }} />}
        />
        {emailCommission && (
          <DisplayCounter
            id="email2"
            title={`Email ${s('sent')}`}
            value={`${data?.emails || 0 * (emailCommission || 0)} ${config.currencyShortSmall}`}
            text={
              emailCommission &&
              p('costPerEmail', {
                commission: emailCommission,
                currency: config.currencyShortSmall,
              })
            }
            icon={<EmailIcon style={{ width: 18 }} />}
          />
        )}
      </div>
    </>
  );
};

export default CommunicationTransactionsList;
